import template from './window.html';
import controller from './window.controller';
import './window.scss';

let windowComponent = {
  restrict: 'E',
  bindings: {
    model: '=ngModel',
    branch: '='
  },
  template,
  controller
};

export default windowComponent;


// WEBPACK FOOTER //
// ./client/app/components/branch/common/window/window.component.js